import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

const ApiKeyService = {
  async list() {
    return (await axios.get(`${API_BASE_URL}/api-keys`)).data;
  },
  async create(name) {
    return (await axios.post(`${API_BASE_URL}/api-keys`, { name })).data;
  },
  async revoke(id) {
    await axios.delete(`${API_BASE_URL}/api-keys/${id}`);
  },
};

export default ApiKeyService;
